module.exports = "img/flags/GI.fea07b9.png";